import React, { useState, useEffect } from "react";
import { useParams } from "react-router";
import { NavLink, useNavigate } from "react-router-dom";

import { db } from "./firebase";
import { collection, getDocs, query, where } from "firebase/firestore";

import moment from "moment";

// images
import Logo from "../images/25.png";
import Gift from "../images/gift.gif";

// components
import "antd/dist/antd.css";
import {
  Button,
  Row,
  Col,
  Affix,
  Badge,
  message,
  Divider,
  Tag,
  Tabs,
  Carousel,
  Upload,
  Modal,
} from "antd";

import {
  LeftCircleOutlined,
  ShoppingOutlined,
  PlusCircleOutlined,
  ShareAltOutlined,
} from "@ant-design/icons";

const CryptoJS = require("crypto-js");

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

function Product() {
  const encrypt = (data) => {
    return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(data));
  };

  const decrypt = (data) => {
    return CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8);
  };

  const { event, id, refcode } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(false);
  const [cart, setCart] = useState(null);

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  let navigate = useNavigate();

  useEffect(() => {
    setLoading(true);

    setRefCode();
    checkStatusWeb();
    getCart();
    getPackages();

    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  const setRefCode = () => {
    if (refcode !== undefined) {
      localStorage.setItem("RefCode", JSON.stringify(decrypt(refcode)));
    }
  };

  const checkStatusWeb = async () => {
    const querySnapshot = await getDocs(
      query(collection(db, "control_web"), where("isactive", "==", false))
    );

    const res = querySnapshot.docs
      .map((doc) => doc.data())
      .filter(
        (x) =>
          moment().format("YYYY-MM-DD HH:mm:ss") >=
            moment().format(x.start_date, "YYYY-MM-DD HH:mm:ss") &&
          moment().format("YYYY-MM-DD HH:mm:ss") <=
            moment().format(x.end_date, "YYYY-MM-DD HH:mm:ss")
      );

    if (res.length !== 0) {
      navigate("/maintain");
    }
  };

  const getCart = async () => {
    if (
      JSON.parse(localStorage.getItem("Cart")) &&
      JSON.parse(localStorage.getItem("Cart")).length !== 0
    ) {
      const querySnapshot = await getDocs(
        query(collection(db, "packages"), where("isactive", "==", true))
      );
      const allPack = querySnapshot.docs.map((doc) => doc.data());

      const cartPack = JSON.parse(localStorage.getItem("Cart")).filter(
        (x) =>
          moment().format("YYYY-MM-DD HH:mm:ss") >=
            moment().format(x.start_date, "YYYY-MM-DD HH:mm:ss") &&
          moment().format("YYYY-MM-DD HH:mm:ss") <=
            moment().format(x.end_date, "YYYY-MM-DD HH:mm:ss") &&
          x.isactive === true
      );

      let arr = [];
      for (let i = 0; i < allPack.length; i++) {
        for (let j = 0; j < cartPack.length; j++) {
          if (
            allPack[i].ecoupon_code === cartPack[j].ecoupon_code &&
            allPack[i].isactive === cartPack[j].isactive &&
            allPack[i].start_date === cartPack[j].start_date &&
            allPack[i].end_date === cartPack[j].end_date
          ) {
            arr.push(cartPack[j]);
          }
        }
      }

      setCart(arr);
      localStorage.removeItem("Cart");
      localStorage.setItem("Cart", JSON.stringify(arr));
    }
  };

  const getPackages = async () => {
    const querySnapshot = await getDocs(
      query(
        collection(db, "packages"),
        where("isactive", "==", true),
        where("ecoupon_code", "==", id)
      )
    );
    const pcks = querySnapshot.docs.map((doc) => doc.data());

    // console.log(pcks)

    const pd = pcks.filter(
      (x) =>
        // x.row_id === parseInt(id) &&
        moment().format("YYYY-MM-DD HH:mm:ss") >=
          moment().format(x.start_date, "YYYY-MM-DD HH:mm:ss") &&
        moment().format("YYYY-MM-DD HH:mm:ss") <=
          moment().format(x.end_date, "YYYY-MM-DD HH:mm:ss")
      //   &&
      // x.isactive === true
    )[0];

    if (pd !== undefined) {
      const querySnapshot2 = await getDocs(
        query(collection(db, "images"), where("ecoupon_code", "==", id))
      );
      const res = querySnapshot2.docs.map((doc) => doc.data());

      if (res.length !== 0) {
        pd.img_list = res[0].img_list;
      } else {
        pd.img_list = [];
      }

      // console.log(pd);

      setProduct(pd);
    } else {
      navigate("/");
    }
  };

  const Loading = () => {
    return (
      <div className="center">
        <img src={Gift} style={{ width: "20%" }} alt="" />
        <br /> <p>Loading...</p>
      </div>
    );
  };

  const addProduct = (product) => {
    let storage_cart = JSON.parse(localStorage.getItem("Cart"));

    if (product.type === "promotion_season") {
      product["n_ecoupon_code"] = product.p_ecoupon_code;
      product["n_price_pro"] = product.p_price_pro;
      product["n_event"] = product.p_event;
      // product["n_row_id"] = product.p_row_id;
      product["n_type"] = product.p_type;
      product["n_img"] = product.p_img;

      product["p_ecoupon_code"] = product.ecoupon_code;
      product["p_price_pro"] = product.price_pro;
      product["p_event"] = product.event;
      // product["p_row_id"] = product.row_id;
      product["p_type"] = product.type;
      product["p_img"] = product.img;
    }

    if (storage_cart == null) {
      product["qty"] = 1;
      localStorage.setItem("Cart", JSON.stringify([product]));

      message.success("เพิ่มสินค้าแล้ว");
    } else {
      const exist = storage_cart.find(
        (x) => x.ecoupon_code === product.ecoupon_code
      );
      if (exist) {
        if (exist.qty === product.max_coupon) {
          message.error("จำกัดคำสั่งซื้อ");
        } else {
          const cart = storage_cart.map((x) =>
            x.ecoupon_code === product.ecoupon_code &&
            x.qty !== product.max_coupon
              ? { ...x, qty: x.qty + 1 }
              : x
          );
          localStorage.removeItem("Cart");
          localStorage.setItem("Cart", JSON.stringify(cart));

          message.success("เพิ่มสินค้าแล้ว");
        }
      } else {
        let cart = JSON.parse(localStorage.getItem("Cart"));
        product["qty"] = 1;
        localStorage.setItem("Cart", JSON.stringify([...cart, product]));

        message.success("เพิ่มสินค้าแล้ว");
      }
    }

    setCart(JSON.parse(localStorage.getItem("Cart")));
  };

  const copyLink = () => {
    const profile = JSON.parse(localStorage.getItem("Profile"));
    const rcode = JSON.parse(localStorage.getItem("RefCode"));
    if (profile && profile.staff_id != null) {
      navigator.clipboard.writeText(
        window.location.href + "/" + encrypt(profile.staff_id)
      );
      message.success("คัดลอกลิงก์สำเร็จ");
    } else {
      if (rcode) {
        navigator.clipboard.writeText(
          window.location.href + "/" + encrypt(rcode)
        );
        message.success("คัดลอกลิงก์สำเร็จ");
      } else {
        navigator.clipboard.writeText(window.location.href);
        message.success("คัดลอกลิงก์สำเร็จ");
      }
    }
  };

  const handlePreview = async (file) => {
    // console.log(file);
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  return (
    <div>
      <Affix offsetTop={0}>
        <div
          style={{
            padding: "20px",
            background: "rgba(255,255,255,0.8)",
            lineHeight: "130%",
          }}
        >
          <>
            <Row>
              <Col style={{ textAlign: "left" }}>
                <LeftCircleOutlined
                  style={{
                    fontSize: "20px",
                    marginTop: "10px",
                    marginRight: "20px",
                    color: "#1e366f",
                  }}
                  onClick={() => navigate("/")}
                />
              </Col>
              <Col flex="auto" style={{ textAlign: "left" }}>
                <span
                  style={{
                    color: "white",
                    fontSize: "20px",
                    paddingRight: "10px",
                  }}
                >
                  <NavLink to="/">
                    {" "}
                    <b>
                      <span style={{ color: "#1e366f", fontSize: "16px" }}>
                        {/* <img src={Logo} alt="" width={35} />  */} Bangkok
                        Hospital Hatyai <br />
                        <span style={{ color: "#b21e2a", fontSize: "14px" }}>
                          Shopping World
                        </span>
                      </span>
                    </b>
                  </NavLink>
                </span>
              </Col>
              <Col style={{ textAlign: "right" }}>
                <Badge count={0}>
                  <div
                    style={{
                      background: "white",
                      borderRadius: "25px",
                      cursor: "pointer",
                      marginRight: "5px",
                    }}
                    onClick={() => copyLink()}
                  >
                    <ShareAltOutlined
                      style={{
                        color: "#1e366f",
                        fontSize: "28px",
                        padding: "7px",
                      }}
                    />
                  </div>
                </Badge>
                <NavLink to="/cart">
                  <Badge
                    count={
                      cart != null
                        ? cart.filter((x) => x.type !== "option").length
                        : null
                    }
                  >
                    <div style={{ background: "white", borderRadius: "25px" }}>
                      <ShoppingOutlined
                        style={{
                          color: "#1e366f",
                          fontSize: "28px",
                          padding: "7px",
                        }}
                      />
                    </div>
                  </Badge>
                </NavLink>
              </Col>
            </Row>
          </>
        </div>
        <Divider style={{ margin: "0px" }} />
      </Affix>
      {loading ? (
        <Loading />
      ) : (
        <>
          <div
            style={{
              borderRadius: "10px",
              height: "100%",
              textAlign: "center",
            }}
          >
            {product !== null ? (
              <>
                {/* {product.img_list.length !== 0 ? (
                    <Carousel>
                      {product.img_list.map((x) => (
                        <>
                          <img src={x} width="100%" alt=""></img>
                        </>
                      ))}
                    </Carousel>
                  ) : (
                    <img src={product.img} width="100%" alt=""></img>
                  )} */}
                <img src={product.img} width="100%" alt=""></img>
                {product.img_list.length !== 0 ? (
                  <>
                    <div
                      style={{
                        textAlign: "left",
                        paddingTop: "10px",
                        paddingBottom: "10px",
                        paddingRight: "10px",
                        paddingLeft: "10px",
                      }}
                    >
                      <Upload
                        onPreview={handlePreview}
                        listType="picture-card"
                        defaultFileList={product.img_list}
                        className="image-upload-grid"
                        showUploadList={{
                          showRemoveIcon: false,
                        }}
                      ></Upload>
                    </div>
                    <br />
                  </>
                ) : (
                  <>
                    <br />
                    <br />
                    <br />
                  </>
                )}
                <div
                  style={{
                    fontSize: "16px",
                    background: "rgba(255,255,255,0.9)",
                    // color:'white',
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    paddingRight: "10px",
                    paddingLeft: "10px",
                    // width:'150px',
                    // borderRadius:'25px'
                  }}
                >
                  {product.name}
                </div>
                {/* <br /> */}
                <p style={{ fontSize: "22px" }}>
                  {
                    // (product.event !== null || product.type == "flashsale") &&
                    product.price !== 0 ? (
                      <>
                        <b style={{ color: "#b21e2a" }}>
                          ฿ {product.price_pro.toLocaleString("en-US")}
                        </b>
                        <br />
                        <span style={{ fontSize: "16px", color: "silver" }}>
                          ราคาปกติ{" "}
                          <span
                            style={{
                              textDecoration: "line-through",
                              textDecorationColor: "red",
                            }}
                          >
                            {product.price.toLocaleString("en-US")}
                          </span>{" "}
                        </span>
                        <Tag
                          style={{ fontSize: "14px", marginLeft: "4px" }}
                          color="red"
                        >
                          Save{" "}
                          {Math.floor(
                            ((product.price - product.price_pro) /
                              product.price) *
                              100
                          )}
                          %
                        </Tag>
                      </>
                    ) : (
                      <>
                        <b style={{ color: "#b21e2a" }}>
                          ฿ {product.price_pro.toLocaleString("en-US")}
                        </b>
                      </>
                    )
                  }
                </p>
                {/* <Button
                  shape="round"
                  type="primary"
                  onClick={() => addProduct(product)}
                  style={{
                    color: "#1e366f",
                    borderColor: "#1e366f",
                    marginBottom: "20px",
                  }}
                  ghost
                  disabled={
                    event !== undefined
                      ? cart != null && cart.length != 0
                        ? product != null && product.event != ""
                          ? cart.find(
                              (x) => x.ecoupon_code === product.event
                            ) == undefined
                            ? true
                            : false
                          : false
                        : product != null && product.event == ""
                        ? false
                        : true
                      : false
                  }
                >
                  เพิ่มไปยังตะกร้า
                  <ShoppingOutlined />
                </Button> */}
                {/* <br /> */}
                {/* <br /> */}
                {product.detail !== "" ? (
                  <Tabs
                    defaultActiveKey="1"
                    style={{
                      paddingLeft: "20px",
                      paddingRight: "20px",
                      textAlign: "left",
                    }}
                    // type="card"
                  >
                    <Tabs.TabPane tab="รายละเอียด" key="1">
                      <br />
                      <span
                        dangerouslySetInnerHTML={{
                          __html: product.detail.replace(/\n/g, "<br/>"),
                        }}
                      />
                    </Tabs.TabPane>
                  </Tabs>
                ) : null}
                <br />
                <br />
              </>
            ) : null}
          </div>
          <Affix offsetBottom={0}>
            <div
              style={{
                padding: "15px",
                backgroundColor: "white",
                boxShadow: "0px 0px 10px #000000",
              }}
            >
              {/* <NavLink to="/cart">
                <Button
                  style={{ width: "100%", background: "#1e366f", border: 0 }}
                  type="primary"
                  size="large"
                  on
                >
                  <Row>
                    <Col span={12} style={{ textAlign: "left" }}>
                      <ShoppingOutlined /> ตะกร้าของฉัน
                    </Col>
                    <Col span={12} style={{ textAlign: "right" }}>
                      ฿{" "}
                      {cart != null
                        ? cart
                            .reduce((accumulator, object) => {
                              return (
                                accumulator + object.price_pro * object.qty
                              );
                            }, 0)
                            .toLocaleString("en-US")
                        : 0}
                    </Col>
                  </Row>
                </Button>
              </NavLink> */}
              <Row gutter={[10, 0]}>
                <Col span={12}>
                  <NavLink to="/cart">
                    <Button
                      type="primary"
                      style={{
                        color: "#1e366f",
                        borderColor: "#1e366f",
                        marginRight: "10px",
                        width: "100%",
                      }}
                      ghost
                      size="large"
                    >
                      <ShoppingOutlined /> ไปยังตะกร้า
                    </Button>
                  </NavLink>
                </Col>
                <Col span={12}>
                  <Button
                    type="primary"
                    style={{
                      // paddingLeft: "15px",
                      // paddingRight: "15px",
                      background: "#1e366f",
                      border: 0,
                      width: "100%",
                    }}
                    size="large"
                    onClick={() => addProduct(product)}
                    disabled={
                      event !== undefined
                        ? cart != null && cart.length != 0
                          ? product != null && product.event != ""
                            ? cart.find(
                                (x) => x.ecoupon_code === product.event
                              ) == undefined
                              ? true
                              : false
                            : false
                          : product != null && product.event == ""
                          ? false
                          : true
                        : false
                    }
                  >
                    <PlusCircleOutlined /> เพิ่มสินค้า
                  </Button>
                </Col>
              </Row>
            </div>
          </Affix>
        </>
      )}
      <Modal
        visible={previewOpen}
        footer={null}
        onCancel={() => setPreviewOpen(false)}
        width="100%"
      >
        <img
          alt="example"
          style={{
            width: "100%",
          }}
          src={previewImage}
        />
      </Modal>
    </div>
  );
}

export default Product;
